<!--/**-->
<!--* 自动生成 vue列表代码【模块名：】-->
<!--* 生成日期：2024/03/11 13:53:57-->
<!--* 生成路径: src/pages/region/RegionList.vue-->
<!--* 生成人：admin-->
<!--*/-->
<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <div class='table-search'>
          <el-form :model='searchCondition' inline size='mini'>
            <el-form-item label='上级ID'>
              <el-input v-model='searchCondition.pid' placeholder='上级ID' clearable></el-input>
            </el-form-item>
            <el-form-item label='区域简称'>
              <el-input v-model='searchCondition.shortname' placeholder='区域简称' clearable></el-input>
            </el-form-item>
            <el-form-item label='区域名称'>
              <el-input v-model='searchCondition.name' placeholder='区域名称' clearable></el-input>
            </el-form-item>
            <el-form-item label='多级名称'>
              <el-input v-model='searchCondition.merger_name' placeholder='多级名称' clearable></el-input>
            </el-form-item>
            <el-form-item label='层级'>
              <el-input v-model='searchCondition.level' placeholder='层级' clearable></el-input>
            </el-form-item>
            <el-form-item label='拼音'>
              <el-input v-model='searchCondition.pinyin' placeholder='拼音' clearable></el-input>
            </el-form-item>
            <el-form-item label='编码'>
              <el-input v-model='searchCondition.code' placeholder='编码' clearable></el-input>
            </el-form-item>
            <el-form-item label='邮政编码'>
              <el-input v-model='searchCondition.zip_code' placeholder='邮政编码' clearable></el-input>
            </el-form-item>
            <el-form-item label='首字母'>
              <el-input v-model='searchCondition.first' placeholder='首字母' clearable></el-input>
            </el-form-item>
            <el-form-item label='经度'>
              <el-input v-model='searchCondition.lng' placeholder='经度' clearable></el-input>
            </el-form-item>
            <el-form-item label='纬度'>
              <el-input v-model='searchCondition.lat' placeholder='纬度' clearable></el-input>
            </el-form-item>

            <el-form-item label='创建时间'>
              <el-date-picker
                v-model='searchCondition.date_range'
                type='daterange'
                align='right'
                unlink-panels
                range-separator='至'
                start-placeholder='开始日期'
                end-placeholder='结束日期'
                value-format='yyyy-MM-dd'
                :picker-options='pickerOptions'>
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' icon='el-icon-search' :disabled='loading' :loading='loading' @click='handleQuery'>搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--        操作栏-->
        <el-row class='mb8' :gutter='10'>
          <el-col :span='1.5'>
            <el-button type='primary' icon='el-icon-plus' @click='handleAdd'>新增</el-button>
          </el-col>
          <el-col :span='1.5'>
            <el-button icon='el-icon-upload' @click='openImport=true'>导入</el-button>
          </el-col>
          <el-col :span='1.5'>
            <export-btn ref='refLogisticSubscribeExport' :can-export='hasAuthority("region_export")' @export='handleExport'></export-btn>
          </el-col>
        </el-row>
        <!--    渲染表格-->
        <div class='default-table'>
          <MlPageTable :all-columns='defaultColumns'
                       :table-name='tableName'
                       :data-list='dataList'
                       :limit.sync='pageData.page_size'
                       :page.sync='pageData.current_page'
                       :total.sync='total'
                       :height='height'
                       highlight-current-row
                       :row-class-name='tableRowClassName'
                       @row-click='rowClickEvent'
                       @getList='getList'>
            <el-table-column align='center' width='120' label='操作'>
              <template slot-scope='{row,$index}'>
                <el-button type='text' icon='el-icon-edit' @click='handleEdit(row)'>修改</el-button>
                <el-button type='text' icon='el-icon-delete' @click='handleDelete(row,$index)'>删除</el-button>
              </template>
            </el-table-column>
          </MlPageTable>
        </div>
      </div>

      <!-- 添加或修改对话框 -->
      <el-dialog :title='title' :visible.sync='open' width='800px' append-to-body :close-on-click-modal='false'>
        <el-form ref='form' :model='form' :rules='rules' label-width='100px'>
          <el-form-item label='上级ID' prop='pid'>
            <el-input v-model='form.pid' placeholder='请输入上级ID' clearable/>
          </el-form-item>
          <el-form-item label='区域简称' prop='shortname'>
            <el-input v-model='form.shortname' placeholder='请输入区域简称' clearable/>
          </el-form-item>
          <el-form-item label='区域名称' prop='name'>
            <el-input v-model='form.name' placeholder='请输入区域名称' clearable/>
          </el-form-item>
          <el-form-item label='多级名称' prop='merger_name'>
            <el-input v-model='form.merger_name' placeholder='请输入多级名称' clearable/>
          </el-form-item>
          <el-form-item label='层级' prop='level'>
            <el-input v-model='form.level' placeholder='请输入层级' clearable/>
          </el-form-item>
          <el-form-item label='拼音' prop='pinyin'>
            <el-input v-model='form.pinyin' placeholder='请输入拼音' clearable/>
          </el-form-item>
          <el-form-item label='编码' prop='code'>
            <el-input v-model='form.code' placeholder='请输入编码' clearable/>
          </el-form-item>
          <el-form-item label='邮政编码' prop='zip_code'>
            <el-input v-model='form.zip_code' placeholder='请输入邮政编码' clearable/>
          </el-form-item>
          <el-form-item label='首字母' prop='first'>
            <el-input v-model='form.first' placeholder='请输入首字母' clearable/>
          </el-form-item>
          <el-form-item label='经度' prop='lng'>
            <el-input v-model='form.lng' placeholder='请输入经度' clearable/>
          </el-form-item>
          <el-form-item label='纬度' prop='lat'>
            <el-input v-model='form.lat' placeholder='请输入纬度' clearable/>
          </el-form-item>

        </el-form>
        <div slot='footer' class='dialog-footer'>
          <el-button type='primary' @click='submitForm' :disabled='loadingCommit' :loading='loadingCommit'>确 定
          </el-button>
          <el-button @click='cancel'>取 消</el-button>
        </div>
      </el-dialog>
      <!--      导入-->
      <ImportRegion :visible.sync='openImport' v-if='hasAuthority("logistic_subscribe_import")' @imported='handleQuery' />
    </PageHeaderLayout>
  </div>
</template>

<script>
import MlPageTable from '@/components/common/MlPageTable'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ExportBtn from '@/components/export/ExportBtn'
import ImportRegion from './import.vue'

export default {
  name: 'RegionList',
  components: { ImportRegion, ExportBtn, PageHeaderLayout, MlPageTable },
  data() {
    return {
      tableName: 'region',
      loading: false,
      loadingCommit: false,
      dataList: [],
      total: 0,
      height: 800,
      searchCondition: { date_range: [],pid: null, shortname: null, name: null, merger_name: null, level: null, pinyin: null, code: null, zip_code: null, first: null, lng: null, lat: null},
      pageData: { current_page: 1, page_size: 100 },
      orderBy: { id: 'asc' },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      defaultColumns:  [{ hide: false, prop: 'id', label: '序号', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'pid', label: '上级ID', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'shortname', label: '区域简称', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'name', label: '区域名称', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'merger_name', label: '多级名称', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'level', label: '层级', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'pinyin', label: '拼音', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'code', label: '编码', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'zip_code', label: '邮政编码', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'first', label: '首字母', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'lng', label: '经度', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'lat', label: '纬度', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'created_at', label: '创建时间', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'updated_at', label: '修改时间', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'deleted_at', label: '删除时间', width: 120, sortable: false, fixed: false }],
      // 弹出层标题
      title: '添加/修改-',
      // 是否显示弹出层
      open: false,
      // 表单校验
      rules:{pid: [{ required: true, message: '上级ID不能为空', trigger: 'blur' }],
        shortname: [{ required: true, message: '区域简称不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '区域名称不能为空', trigger: 'blur' }],
        merger_name: [{ required: true, message: '多级名称不能为空', trigger: 'blur' }],
        level: [{ required: true, message: '层级不能为空', trigger: 'blur' }],
        pinyin: [{ required: true, message: '拼音不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        zip_code: [{ required: true, message: '邮政编码不能为空', trigger: 'blur' }],
        first: [{ required: true, message: '首字母不能为空', trigger: 'blur' }],
        lng: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
        lat: [{ required: true, message: '纬度不能为空', trigger: 'blur' }]},
      // 表单参数
      form: {},
      //是否显示弹出层:导入框
      openImport: false,
      //筛选条件缓存key
      pageSearchKey:'page_search_key:region'
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    rowClickEvent(row, column, event) {
      // this.$notify.info(`数据ID：${row.id}`)
    },
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({ row, rowIndex }) {
      return 'default-table-row'
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (field !== 'date_range' && this.searchCondition[field]) {
          // console.log(Object.prototype.toString.call(this.searchCondition[field]))
          // console.log((this.searchCondition[field]).constructor)
          // console.log(typeof (this.searchCondition[field]))

          condition[field] = this.searchCondition[field]
        }
      })

      if (this.searchCondition.date_range) {
        condition.date_range = this.searchCondition.date_range
      }

      // 分页 +排序
      Object.assign(condition, this.pageData, { orderBy: this.orderBy })

      return condition
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
    },
    async getList() {
      this.dataList = []
      this.loading = true
      const params = this.handleSearchCondition()
      const { list, pages } = await this.$api.getRegionList(params)
      // this.dataList = [...this.dataList, ...list]
      this.dataList = list
      this.pageData.current_page = pages.current_page || 1
      this.pageData.page_size = pages.page_size || 100
      this.total = pages.total
      this.loading = false
    },
    /** 删除按钮 */
    handleDelete(row, index) {
      if (row.id) {
        //真实删除
        this.$confirm('此操作将删除该行数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delRow(row.id)
          this.dataList.splice(index, 1)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.tableData.splice(index, 1)
      }
    },
    delRow(id) {
      this.$api.deleteRegion(id)
    },
    /** 修改按钮 */
    handleAdd() {
      this.open = true
      this.title = '添加-'
      // let { info } = await this.$api.getRegionInfo(row.id)
      this.form = {}
    },
    /** 修改按钮 */
    async handleEdit(row) {
      this.open = true
      this.title = '修改-'
      // let { info } = await this.$api.getRegionInfo(row.id)
      this.form = { ...row }
    },

    /** 提交按钮 */
    async submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loadingCommit = true
          this.$api.saveRegion(this.form).then(id => {
            if (id) {
              if (!this.form.id)
                this.msgSuccess('新增成功')
              else
                this.msgSuccess('修改成功')

              this.form.id = id
              this.open = false
              this.getList()
            } else {
              this.msgError('操作失败')
            }
            setTimeout(() => {
              this.loadingCommit = false
            }, 500)
          })

        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.form = {}
    },
    //导出表格
    async handleExport() {
      try {
        const searchCondition = this.handleSearchCondition()
        const response = await this.$api.exportRegions(searchCondition)
        const name = `订阅消息`

        this.$refs.refLogisticSubscribeExport.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
        this.$refs.refLogisticSubscribeExport.hideLoading()
      }
    },
  },
  created() {
    if (sessionStorage.getItem(this.pageSearchKey)) {
      this.searchCondition = JSON.parse(sessionStorage.getItem(this.pageSearchKey))
    }
    this.handleQuery()
  }
}
</script>

<style scoped>

</style>
